<template>
  <slo-modal :maxWidth="850" @formSubmit="save()" @dismiss="cancel()">
    <template v-slot:title>
      {{ 'Edit Cover Image' | t }}
    </template>
    <section v-stack-y:lg>
      <slo-field tag="div">
        <slo-radio-images
          :images="coverImages"
          name="cover_image_id"
          :value="cover_image_id"
          @input="updateProject('cover_image_id', $event)"
          fallback="/themes/sloan/img/design-spec-placeholder.png"
        />
      </slo-field>
    </section>
    <template v-slot:footer>
      <slo-button fill="outline" @click="cancel()">{{ 'Cancel' | t }}</slo-button>
      <slo-button type="submit">{{ 'Save' | t }}</slo-button>
    </template>
  </slo-modal>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import SloModal from '../../../../lib/components/SloModal.vue';
import SloField from '../../../../lib/components/SloField.vue';
import SloButton from '../../../../lib/components/SloButton.vue';
import SloRadioImages from '../../../../lib/components/SloRadioImages.vue';
import t from '../../../main/i18n';

export default {
  components: {
    SloModal,
    SloField,
    SloButton,
    SloRadioImages
  },
  data() {
    return {
      images: [],
      error: null,
      initialState: null
    };
  },
  filters: {
    t
  },
  created() {
    const {cover_image_id} = this.getProject(Number(this.$route.params.id));
    this.initialState = {
      id: Number(this.$route.params.id),
      cover_image_id
    };
  },
  computed: {
    ...mapGetters('designspec', {getProject: 'project'}),
    ...mapState('designspec', {coverImages: state => state.coverImages}),
    project() {
      return this.getProject(Number(this.$route.params.id));
    },
    cover_image_id() {
      return this.project.cover_image_id;
    }
  },
  methods: {
    cancel() {
      this.$store.dispatch('designspec/updateProject', this.initialState);
      this.$router.back();
    },
    save() {
      this.$store.dispatch('designspec/saveProject', {
        id: this.project.id
      });
      this.$router.replace(`/designspec/project/${this.project.id}`);
    },
    updateProject(name, value) {
      this.$store.dispatch('designspec/updateProject', {
        id: this.project.id,
        [name]: value
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../scss/system';

h3 {
  @include text('base', 'strong');
}
</style>
